import { FC, ReactNode, useState } from "react";
import { BsQuestionCircle } from "react-icons/bs";
import styled from "styled-components";
import Tinymce from "../../Tinymce";
import FeedbackGuideModal from "./modals/FeedbackGuideModal";
import { Drawer } from 'antd';

const Block = styled.div`
  h1 {
    text-decoration: underline;
  }

  .sentence {
    border: 1px solid #e8e8e8;
    padding: 10px 5px;
    text-align: left;
    background: #e9e6ee;
    font-size: 18px;
    white-space: pre-wrap;  
  }

  .count {
    border: 0.5px solid #ccc;
    border-top: none;
    text-align: right;
    padding-right: 10px;
  }
`;

interface IProps {
  comment: string;
  setComment: (comment: string) => void;
  feedbackTypeCode: string;
  revision?: string;
  setRevision?: (revision: string) => void;
  isOcta?: boolean;
  sentences?: string[];
  revisions?: string[];
  test?: string[];
  setRevisions?: (revisions: string[]) => void;
  eduStepCode?: string;
  isRewrite?: boolean;
  displayName?: string;
}

const CommentEditor: FC<IProps> = ({
  comment,
  setComment,
  feedbackTypeCode,
  revision,
  setRevision,
  isOcta,
  sentences,
  revisions,
  setRevisions,
  eduStepCode,
  test,
  isRewrite,
  displayName
}) => {
  const [showGuideVisible, setShowGuideVisible] = useState(false);
  const onSetRevisions = (index: number, revision: string) => {
    if (setRevisions) {
      const newRevisions = [...revisions!];
      newRevisions[index] = revision;
      setRevisions(newRevisions);
    }
  };

  const renderEditors = () => {
    if (!sentences) return null;

    const nodes: ReactNode[] = [];
    nodes.push(
      <div className="subtitle mt-4">
        <h3>Feedback by {isOcta ? 'Structure' : 'Paragraph'}</h3>
      </div>
    );

    sentences.forEach((sentence, index) => {
      nodes.push(
        <>
          <div className="sentence">{sentence}</div>
          <Tinymce
            content={revisions![index] || ''}
            setContent={(content) => onSetRevisions(index, content)}
            charLimit={2000}
          />
          {renderCounter(revisions![index])}
        </>,
      );
    });

    return nodes;
  };

  const renderCounter = (value: any) => {
    return (
      <div className="count">{value?.length || 0} Characters (with tags)</div>
    );
  };

  return (
    <Block>
      <div className="row">
        <div
          className="col-1 pointer"
          onClick={() => setShowGuideVisible(true)}
        >
          <div>
            <BsQuestionCircle color="black" />
            <p
              className="mb-0"
              style={{ color: 'black' }}
            >
              Guide!
            </p>
          </div>
        </div>
        <div className="col-10">
          <h1>{displayName === 'Creative Speaking' && !isRewrite ? 'Teachers feedback' : 'Overall Assessment'}</h1>
        </div>
        <div className="col-1" />
      </div>
      <Tinymce
        content={comment}
        setContent={setComment}
        charLimit={2000}
      />
      {renderCounter(comment)}

      {
        feedbackTypeCode === 'ST'
          ? (
            <>
              <div className="subtitle mt-4">
                <h3>Sentence Revision</h3>
              </div>
              <Tinymce
                content={revision!}
                setContent={setRevision!}
                charLimit={2000}
              />
              {renderCounter(comment)}
            </>
            )
          : renderEditors()
      }

      {showGuideVisible &&
        <FeedbackGuideModal
          visible={showGuideVisible}
          setVisible={setShowGuideVisible}
          feedbackTypeCode={feedbackTypeCode}
          isRewrite={isRewrite}
        />
      }
    </Block>
  );
}

export default CommentEditor;
